import { motion } from "framer-motion";

export default function Marquee({ items }) {
  const loop = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-edge bg-cream/60" data-testid="brand-marquee">
      <motion.div
        className="marquee-track py-6"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 38, ease: "linear", repeat: Infinity }}
      >
        {loop.map((t, i) => (
          <span key={i} className="font-serif italic text-3xl md:text-4xl text-charred mx-8 whitespace-nowrap">
            {t} <span className="text-ember mx-4">✺</span>
          </span>
        ))}
      </motion.div>
    </div>
  );
}
